/**
 * Lightweight modal open/close helper.
 * Uses CSS opacity transitions — modals are expected to have
 * `display:none` when hidden and `opacity:0 → 1` on open.
 */
export const Modal = {
    open(id) {
        const modal = document.getElementById(id);
        if (!modal) return;
        modal.style.display = 'block';
        requestAnimationFrame(() => { modal.style.opacity = 1; });
    },

    close(id, delay = 200) {
        const modal = document.getElementById(id);
        if (!modal) return;
        modal.style.opacity = 0;
        setTimeout(() => { modal.style.display = 'none'; }, delay);
    },

    isOpen(id) {
        const modal = document.getElementById(id);
        return modal ? modal.style.display !== 'none' && modal.style.opacity !== '0' : false;
    },
};
